exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-dropdown-menu[data-v-d2a69d08]{height:30px;width:100px}.van-dropdown-menu__title[data-v-d2a69d08]{font-size:14px}.van-hairline--top-bottom[data-v-d2a69d08]:after{border:0 solid #fff;font-size:14px}", ""]);

// exports
